<template>
  <div id="Register">
    <van-notice-bar color="#1989fa" background="#ecf9ff" left-icon="info-o">所属机构信息很多,通过输入关键字可以快速查找,提交申请后由机构管理员审核账号信息,管理员启用账号后才可以登录</van-notice-bar>

    <div class="pt-1">
      <div class="m-2">
        <el-select v-model="organid" filterable placeholder="请选择所属机构" style="width:100%">
          <!-- <el-option v-for="(item,index) in options" :key="index" :label="item.OrganName" :value="item.OrganID"></el-option>-->
          <el-option-group v-for="group in options" :key="group.label" :label="group.label">
            <el-option
              v-for="item in group.options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-option-group>
        </el-select>
      </div>
    </div>

    <div class="m-2">
      <van-cell class="border-radius">
        <van-field v-model="reg_name" label="登录账号" placeholder="登陆账号长度不能少于 4 位" />
        <van-field v-model="reg_password" type="password" label="输入密码" placeholder="密码长度不能少于 6 位" />
        <van-field
          v-model="confirm_password"
          type="password"
          label="确认密码"
          placeholder="密码长度不能少于 6 位"
        />
        <van-field v-model="real_name" label="用户姓名" placeholder="请输入真实姓名" />
        <van-field v-model="mobile_phone" label="联系方式" placeholder="请输入手机号" />
      </van-cell>
    </div>

    <div class="m-2">
      <van-button class="mt-4 w-100" hairline type="info" @click="registerBtn">注册</van-button>
    </div>
  </div>
</template>

<script>
export default {
  id: "Register",
  data() {
    return {
      options: [],
      organid: "",
      reg_name: "",
      reg_password: "",
      confirm_password: "",
      real_name: "",
      mobile_phone: ""
    };
  },
  methods: {
    registerBtn: function() {
      if (this.organid == "") {
        this.$toast("所属单位项必选");
        return;
      }
      /**验证用户名 */
      if (this.reg_name.length == 0) {
        this.$toast("登录账号不能为空");
        return;
      } else if (this.reg_name.length < 4) {
        this.$toast("登陆账号长度不能少于 4 位");
        return;
      }
      /**验证密码 */
      if (this.reg_password != this.confirm_password) {
        this.$toast("两次输入的密码不相同");
        return;
      }
      if (this.reg_password.length == 0) {
        this.$toast("密码不能为空");
        return;
      } else if (this.reg_password.length < 6) {
        this.$toast("密码长度不能少于 6 位");
        return;
      }
      /**验证姓名 */
      if (this.real_name.length == 0) {
        this.$toast("真实姓名不能为空");
        return;
      }
      /**验证手机号 */
      if (!/^1[3456789]\d{9}$/.test(this.mobile_phone)) {
        this.$toast("手机号码有误");
        return false;
      }
      var json = {
        UserName: this.reg_name,
        Password: this.reg_password,
        RealName: this.real_name,
        Phone: this.mobile_phone,
        OrganID: this.organid
      };
      this.apiUserPost(json, this, res => {
        if (res.code == 20000) {
          //注册成功
          this.$router.push({ name: "Login" });
        }
        this.$toast(res.message);
      });
    }
  },
  created() {
    this.apiOrganGet(this, res => {
      this.options = [
        { label: "省直", options: [] },
        { label: "考区", options: [] },
        { label: "院校", options: [] }
      ];
      res.data.forEach(element => {
        switch (element.OrganType) {
          case 1:
            this.options[0].options.push({
              label: element.OrganName,
              value: element.OrganID
            });
            break;
          case 2:
            this.options[1].options.push({
              label: element.OrganName,
              value: element.OrganID
            });
            break;
          case 3:
            this.options[2].options.push({
              label: element.OrganName,
              value: element.OrganID
            });
            break;
        }
      });
    });
  }
};
</script>

<style scoped>
#Register {
  background: #fff;
}
</style>
